import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import api from '../../api'
import { ProjectContext } from '../../contexts'
import Alert from '../../ui/Alert'
import PageContent from '../../ui/PageContent'

/**
 * Where the completion email lands. Fetching the record first means an expired
 * session redirects to login and returns here, instead of the browser being
 * sent straight at the API and rendering a raw 401.
 */
export default function ExportDownload() {
    const { t } = useTranslation()
    const { exportId = '' } = useParams()
    const [project] = useContext(ProjectContext)
    const [error, setError] = useState<string | undefined>()

    useEffect(() => {
        api.exports.get(project.id, exportId)
            .then(record => {
                if (record.state === 'complete') {
                    window.location.href = api.exports.downloadUrl(project.id, record.id)
                } else {
                    setError(t(record.state === 'expired' ? 'export_expired_detail' : 'export_unavailable_detail'))
                }
            })
            .catch(() => setError(t('export_unavailable_detail')))
    }, [project.id, exportId])

    return (
        <PageContent title={t('export_download_title')}>
            {error
                ? <Alert variant="error" title={t('export_unavailable_title')}>{error}</Alert>
                : <Alert variant="plain" title={t('export_download_title')}>{t('export_download_starting')}</Alert>
            }
        </PageContent>
    )
}
